import type { TaxonomyItem } from '../../../modules.model';

/**
 * Module code of the Billing page. Lives here rather than on the component so the
 * app shell (user menu) can resolve the page without pulling the whole template
 * out of its lazy chunk.
 */
export const BILLING_PAGE_CODE = 'billing';

/** A stored reference to another module entry, as written by autocomplete fields. */
export interface ModuleReference {
  id?: string;
  selectedInput?: string;
}

/** A taxonomy-backed value can be stored as the option object or as a bare slug/id. */
export type TaxonomyValue = TaxonomyItem | string | undefined;

export const SubscriptionStatusEnum = <const>{
  Actief: 'actief',
  OpzeggingAangevraagd: 'opzegging-aangevraagd',
  OpzeggingGoedgekeurd: 'opzegging-goedgekeurd',
  Opgezegd: 'opgezegd',
  HervattingAangevraagd: 'hervatting-aangevraagd',
};
export type SubscriptionStatus = (typeof SubscriptionStatusEnum)[keyof typeof SubscriptionStatusEnum];

/**
 * Fallback labels for when the status was stored as a bare slug, or the module
 * taxonomy that normally supplies the label has not loaded. Without these the card
 * would read "Actief" while the subscription is actually being wound down.
 */
export const SUBSCRIPTION_STATUS_LABELS: Readonly<Record<SubscriptionStatus, string>> = {
  [SubscriptionStatusEnum.Actief]: 'Actief',
  [SubscriptionStatusEnum.OpzeggingAangevraagd]: 'Opzegging aangevraagd',
  [SubscriptionStatusEnum.OpzeggingGoedgekeurd]: 'Opzegging goedgekeurd',
  [SubscriptionStatusEnum.Opgezegd]: 'Opgezegd',
  [SubscriptionStatusEnum.HervattingAangevraagd]: 'Hervatting aangevraagd',
};

export interface CancellationRequest {
  reason: TaxonomyItem | null;
  note: string;
}

export interface CancellationDialogData {
  reasons: TaxonomyItem[];
}
